<template>
  <section-main>
    <section-title title="projekty" />
    <div class="projects">
      <project-tile
        v-for="(project, i) in projects"
        :key="i"
        :title="project.name"
        :logo="project.logo"
        :scopes="project.scope"
        :is-active-tile="isActive(i)"
        @click="handleToggle(i)"
      />
      <project-tile
        scopes="miejsce na Twój projekt"
      />
    </div>
  </section-main>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'
import ProjectTile from '@/components/ProjectTile'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    SectionTitle,
    ProjectTile
  },
  data () {
    return {
      isActiveTile: -1
    }
  },
  computed: {
    ...mapState({
      projects: state => state.projects.items
    }),
    isActive () {
      return i => i === this.isActiveTile
    }
  },
  mounted () {
    this.fetchProjects()
  },
  methods: {
    ...mapActions(['fetchProjects']),
    handleToggle (i) {
      this.isActiveTile = this.isActiveTile === i ? -1 : i
    }
  }
}
</script>

<style lang="scss" scoped>
  .projects {
    display: flex;
    flex-wrap: wrap;
  }
</style>



// WEBPACK FOOTER //
// src/views/Projects.vue